<template>
    <div>
        <PrimeToast />

        <div id="login-form-wrapper" v-if="!isAuthorized" class="flex align-content-center flex-wrap">
            <div class="login-form m-auto"  style="max-width: 350px;">
                <img src="/img/logo.png" alt="">

                <div class="p-inputgroup">
                    <InputText placeholder="Email" v-model="loginForm.username"/>
                </div>

                <div class="p-inputgroup mt-2">

                    <InputText placeholder="Пароль"  type="password" v-model="loginForm.password" @keydown.enter="onSubmitForm" />
                </div>
                <div class="flex align-content-start mt-2">
                    <PrimeButton label="Войти" @click="onSubmitForm"/>
                </div>


            </div>
        </div>

        <div id="page-wrapper" v-else>


            <div
                id="side-menu"
                :class="{ collapsed: isSidebarVisuallyCollapsed, 'hover-expanded': sidebarHoverExpanded }"
                @mouseenter="onSidebarMouseEnter"
                @mouseleave="onSidebarMouseLeave"
            >
                <div id="logo" v-if="!isSidebarVisuallyCollapsed">
                    <a href="/"><img src="/img/logo.png" alt=""></a>
                </div>
                <SideMenu
                    :collapsed="isSidebarVisuallyCollapsed"
                    @navigate="onSidebarNavigate"
                ></SideMenu>
            </div>
            <div id="content-placeholder">
                <!--div id="menu-navbar">
                    top menu
                </div-->
                <div id="content-wrapper">
                    <router-view/>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

import SideMenu from "@/components/SideMenu";
import EventBus from "@/libs/event-bus";
import events from "@/libs/events";


import {user} from "@/libs/auth"

export default {
    name: 'App',
    data() {
        return {
            isAuthorized: false,
            sidebarHoverExpanded: false,
            loginForm:{
                username: '',
                password: ''
            }
        }
    },
    components: {
        SideMenu
    },
    computed: {
        isSidebarVisuallyCollapsed() {
            return !this.sidebarHoverExpanded;
        }
    },
    methods:{
        onSidebarMouseEnter() {
            this.sidebarHoverExpanded = true;
        },
        onSidebarMouseLeave() {
            this.sidebarHoverExpanded = false;
        },
        onSidebarNavigate() {
            this.sidebarHoverExpanded = false;
        },
        onSubmitForm(){
            console.log('on submit form', {...this.loginForm});
            user.login(this.loginForm.username, this.loginForm.password).
            then(response => {
                if(response.data.success) {
                    this.isAuthorized = true;
                }
            }).catch(err => {
                console.error('Login error:', err);
                // Можно добавить обработку ошибок авторизации
            })
        }
    },
    mounted() {
        this.isAuthorized = user.isAuthorized();
        EventBus.$on(events.STATUS_401_UNAUTHORIZED, () =>{
            this.isAuthorized = false;
        });
        EventBus.$on(events.LOGOFF, () =>{
            this.isAuthorized = false;
            console.log('log off')
            window.location.href="/";
        });

    }
}
</script>

<style lang="scss">
html,
body {
    margin: 0;
    height: 100%;
    overflow: hidden;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100vh;
    overflow: hidden;
}

#login-form-wrapper{
    width: 100%;
    height: 100vh;
    display: table;

    min-width: 320px !important;
    min-height: 100vh;
    overflow: auto;
}
#page-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;

    min-width: 320px !important;
    overflow: hidden;
}

#side-menu {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 250px;
    height: 100vh;
    overflow: hidden;
    vertical-align: top;
    background-color: #0059a9;
    -webkit-box-shadow: -1px 0 0 #0059a9;
    box-shadow: -1px 0 0 #0059a9;
    flex-shrink: 0;
    transition: width 0.25s ease;
}

#side-menu.collapsed {
    width: 56px;
}

#content-placeholder {

    margin-left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    //display: table-cell;
    position: relative;
    min-height: 100%;
}

#menu-navbar {
    box-shadow: 1px 2px 10px rgb(0 0 0 / 4%);
    margin-bottom: 0;
    background-color: #fff;
    border-radius: 0;
    border: 0;
    padding-left: 26px;
    padding-right: 24px;
    position: relative;
    min-height: 45px;
}

#logo {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 1px 2px 10px rgb(0 0 0 / 4%);
    margin-bottom: 0;
    background-color: #fff;
    border-radius: 0;
    border: 0;
    padding: 12px 20px;
    position: relative;
    min-height: 68px;
    box-sizing: border-box;
}

#logo img {
    display: block;
    max-width: 185px;
    max-height: 52px;
    width: auto;
    height: auto;
}

#content-wrapper {
    height: 100vh;
    padding: 28px 32px 24px;
    box-sizing: border-box;
    overflow: auto;
}
</style>
